var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.info)?_c('span',[_vm._v(_vm._s(_vm.info.email)),(!_vm.islast)?_c('span',[_vm._v("; ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }